import * as types from './actionTypes';
import { getRequest, postRequest } from '../../lib/apiUtils';

const listType = "EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST";
const listName = "externalCampaignListParticipantsList";

export function getExternalCampaignListDetails(campaignListId, dispatchLoading = true) {
    return async dispatch => {
        if (dispatchLoading)
            dispatch({ type: types.START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS });

        let response = await getRequest(`/campaignLists/${campaignListId}`);

        dispatch({ type: types.GET_EXTERNAL_CAMPAIGN_LIST_DETAILS, response });
    };
}

export function getExternalCampaignListRecipients(campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS });

        const response = await getRequest(`/campaignLists/${campaignListId}/externalRecipients`, null, []);

        dispatch({ type: types.GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS, response });
    };
}

export function updateListConfigs(configs) {
    return dispatch => {
        dispatch({ type: types[`UPDATE_${listType}_CONFIGS`], configs });
    }
}

export function getExternalCampaignListParticipants(campaignListId, type = 'new', keyword = "", reset = false, page = 1, sort = { by: 'name', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        dispatch(updateListConfigs({
            filters: { keyword, type },
            page,
            sort
        })); //sending in with each request, but storing in redux to allow other actions to access

        const requestId = ++getState()[listName].currentRequestId;
        dispatch({ type: types[`START_GET_${listType}_RECORDS`], requestId, reset });

        const listSettings = getState()[listName];
        let params = {
            keyword: listSettings.filters.keyword,
            page: listSettings.page,
            results: listSettings.results,
            sortBy: listSettings.sort.by,
            sortDirection: listSettings.sort.direction,
            type: listSettings.filters.type
        };
        const response = await getRequest(`/campaignLists/${campaignListId}/externalParticipants`, params);

        dispatch({ type: types[`GET_${listType}_RECORDS`], response, requestId });
    };
}

export function exportExternalCampaignList(campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_EXPORT_EXTERNAL_CAMPAIGN_LIST });

        const response = await getRequest(`/campaignLists/${campaignListId}/externalParticipants`, { report: true }, []);

        dispatch({ type: types.EXPORT_EXTERNAL_CAMPAIGN_LIST, response });
    }
}

export function submitExternalCampaignList(campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_SUBMIT_EXTERNAL_CAMPAIGN_LIST });

        const response = await postRequest(`/campaignLists/${campaignListId}/submitExternalChanges`);

        dispatch({ type: types.SUBMIT_EXTERNAL_CAMPAIGN_LIST, response });
    }
}

export function addExternalCampaignListParticipant(campaignListId, participant) {
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS });

        const response = await postRequest(`/campaignLists/${campaignListId}/externalParticipants`, participant);

        dispatch({ type: types.UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS, response });

        if (response.success) {
            dispatch(onUpdateList(campaignListId));
            dispatch(getExternalCampaignListParticipants(campaignListId, 'new', "", true));
        }
    };
}

export function updateExternalCampaignListParticipant(campaignListId, participant) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS });

        const response = await postRequest(`/campaignLists/${campaignListId}/externalParticipants/${participant.externalListMemberId}/update`, participant);

        if (response.success) {
            const participants = [...getState()[listName].data.records];
            const participantIndex = participants.map(p => p.externalListMemberId).indexOf(participant.externalListMemberId);
            participants[participantIndex] = response.data;
            await dispatch(onUpdateList(campaignListId, participants));
        }

        dispatch({ type: types.UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS, response });
    };
}

export function removeExternalCampaignListParticipant(campaignListId, participantExternalListMemberId) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS });

        const response = await postRequest(`/campaignLists/${campaignListId}/externalParticipants/${participantExternalListMemberId}/remove`);

        if (response.success) {
            const participants = [...getState()[listName].data.records];
            const participantIndex = participants.map(p => p.externalListMemberId).indexOf(participantExternalListMemberId);
            participants[participantIndex].isRemoved = true;
            participants[participantIndex].isReceiving = false;
            await dispatch(onUpdateList(campaignListId, participants));
        }

        dispatch({ type: types.UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS, response });
    };
}

export function restoreExternalCampaignListParticipant(campaignListId, participantExternalListMemberId) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS });

        const response = await postRequest(`/campaignLists/${campaignListId}/externalParticipants/${participantExternalListMemberId}/restore`);

        if (response.success) {
            const participants = [...getState()[listName].data.records];
            const participantIndex = participants.map(p => p.externalListMemberId).indexOf(participantExternalListMemberId);
            participants[participantIndex].isRemoved = false;
            await dispatch(onUpdateList(campaignListId, participants));
        }

        dispatch({ type: types.UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS, response });
    };
}

export function toggleExternalCampaignListParticipantsReceiving(campaignListId, isReceiving, isNotReceiving, toggleAll, type, keyword) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS });

        const toggleDetails = {
            isReceiving,
            isNotReceiving
        };

        if (toggleAll) {
            toggleDetails.keyword = keyword;
            toggleDetails.type = type;
            if (toggleAll === "all")
                toggleDetails.allReceiving = true;
            else if (toggleAll === "none")
                toggleDetails.noneReceiving = true;
        }

        const response = await postRequest(`/campaignLists/${campaignListId}/externalParticipants/receiving`, toggleDetails);

        if (response.success) {
            const participants = [...getState()[listName].data.records];

            //update records in current list
            if (toggleDetails.allReceiving) {
                participants.forEach(participant => participant.isReceiving = true);
            } else if (toggleDetails.noneReceiving) {
                participants.forEach(participant => participant.isReceiving = false);
            } else {
                isReceiving.forEach(participantId => {
                    const participantIndex = participants.map(p => p.externalListMemberId).indexOf(participantId);
                    if (participants[participantIndex])
                        participants[participantIndex].isReceiving = true;
                });
                isNotReceiving.forEach(participantId => {
                    const participantIndex = participants.map(p => p.externalListMemberId).indexOf(participantId);
                    if (participants[participantIndex])
                        participants[participantIndex].isReceiving = false;
                });
            }

            await dispatch(onUpdateList(campaignListId, participants, false)); // no totalCount update
        }

        dispatch({ type: types.SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS, response });
    };
}

export function onUpdateList(campaignListId, records, getTotalCount = true) {
    return async (dispatch, getState) => {

        dispatch(getExternalCampaignListDetails(campaignListId, false));

        if (records) {
            const listSettings = getState()[listName];
            let params = {
                noRecords: true,
                noTotalCount: !getTotalCount,

                keyword: listSettings.filters.keyword,
                page: listSettings.page,
                results: listSettings.results,
                sortBy: listSettings.sort.by,
                sortDirection: listSettings.sort.direction,
                type: listSettings.filters.type
            };
            const response = await getRequest(`/campaignLists/${campaignListId}/externalParticipants`, params);

            dispatch({
                type: types[`UPDATE_${listType}_DATA`],
                data: {
                    allSelected: response.data.allSelected,
                    totalCount: getTotalCount ? response.data.totalCount : listSettings.data.totalCount,
                    records //getting records with manual updates bec not requesting all pages that may contain updates..
                }
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/redux/actions/ExternalCampaignListsActions.js